'use client';

import type { ReactNode } from 'react';

import { useTrackEvent } from '@/lib/posthog';

import type { TemplateFormat } from '../_lib/template-lines';

interface TemplateDownloadLinkProps {
  slug: string;
  format: TemplateFormat;
  variant: 'primary' | 'secondary';
  children: ReactNode;
}

export function TemplateDownloadLink({
  slug,
  format,
  variant,
  children,
}: TemplateDownloadLinkProps) {
  const { trackEvent } = useTrackEvent();
  return (
    <a
      className={`btn btn-${variant}`}
      href={`/guides/${slug}/template/${format}`}
      download
      onClick={() =>
        trackEvent('GUIDE_TEMPLATE_DOWNLOADED', { guide_slug: slug, format }, { source: 'client' })
      }
    >
      {children}
    </a>
  );
}
